import React, { FC } from 'react'
import { HStack, Typography, XelaColor } from '@/XelaReact'
import { router } from '@inertiajs/react'
import Notification = App.Models.Notification

const AgentVisaTransitionNotification: FC<{
  notification: Notification
  portal?: string
}> = ({ notification, portal = 'Agency' }) => {
  return (
    <HStack
      spacing="3px"
      style={{
        flexWrap: 'wrap',
        cursor: 'pointer',
        padding: '12px',
      }}
      onClick={() => {
        if (portal === 'B2B') {
          router.visit('/b2b/leads/' + notification.data.lead_id)
        }
      }}
    >
      <Typography variant="body-small" color={XelaColor.Gray6}>
        Agent
      </Typography>
      <Typography variant="body-small" color={XelaColor.Pink3}>
        {notification.data.event_by}
      </Typography>
      <Typography variant="body-small" color={XelaColor.Gray6}>
        update visa status for
      </Typography>
      <Typography variant="body-small-bold" color={XelaColor.Gray3}>
        #{notification.data.lead_name}
      </Typography>
      <Typography variant="body-small" color={XelaColor.Gray6}>
        to {notification.data.agent_visa_status}
      </Typography>
    </HStack>
  )
}

export default AgentVisaTransitionNotification
